import React from 'react';
import { Section, GoldDivider } from './Section';
import { BulletList } from './BulletList';
import { CtaButton, CHECKOUT_URL } from './CtaButton';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/iRRTmm5ivv8LMRg7g8YBUw/Kamasutra_para_enamorar.jpg';
const BEATRIZ_IMAGE = 'https://cdn.magicpatterns.com/uploads/nobKpirtzjewmFM8AgHixP/Foto_Bea.jpg';
/* Shared helpers ---------------------------------------------------------- */
function SectionTitle({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="relative" data-id="element-8">
      {/* Diffuse gold glow behind key headings */}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-40 w-[120%] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-40 blur-3xl" style={{
      background: 'radial-gradient(closest-side, rgba(201,162,75,0.35), transparent)'
    }} data-id="element-9" />
      <h2 className="font-serif-editorial relative text-[32px] font-bold leading-[1.15] text-[#F5EDE4] sm:text-[40px] md:text-[44px]" data-id="element-10">
        {children}
      </h2>
    </div>;
}
function Lead({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <p className={`text-[17px] leading-[1.7] text-[#F5EDE4] sm:text-[19px] ${className}`} data-id="element-11">
      {children}
    </p>;
}
function Secondary({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <p className={`text-[17px] leading-[1.7] text-[#E7C9B8] sm:text-[18px] ${className}`} data-id="element-12">
      {children}
    </p>;
}
const gold = 'text-[#C9A24B]';
const magenta = 'text-[#C41E5A]';
/* Page -------------------------------------------------------------------- */
export function SalesPage() {
  return <div className="relative min-h-full w-full overflow-x-hidden bg-[#1A1014]" data-id="element-13">
      {/* Global ambient radial textures (burgundy → black) */}
      <div aria-hidden="true" className="pointer-events-none fixed inset-0" style={{
      background: 'radial-gradient(1200px 800px at 50% -5%, rgba(59,10,30,0.9), transparent 60%), radial-gradient(900px 700px at 90% 30%, rgba(59,10,30,0.5), transparent 55%), radial-gradient(1000px 900px at 0% 80%, rgba(59,10,30,0.45), transparent 60%)'
    }} data-id="element-14" />

      <div className="relative mx-auto max-w-[640px] px-5 pb-32 sm:px-8 lg:pb-24" data-id="element-15">
        {/* HEADER BANNER — the uploaded image IS the hero */}
        <header className="pt-6 sm:pt-10" data-id="element-16">
          <img src={HERO_IMAGE} alt="Kamasutra para Enamorar — Masterclass Premium con la Msc. Beatriz Espina, Sexóloga y Especialista en Conducta" className="w-full rounded-2xl object-cover shadow-2xl ring-1 ring-[#C9A24B]/20" style={{
          boxShadow: '0 30px 80px -30px rgba(0,0,0,0.9)'
        }} data-id="element-17" />
        </header>

        <main className="pt-14 sm:pt-20" data-id="element-18">
          {/* SECCIÓN 1 */}
          <Section className="space-y-5" data-id="element-19">
            <SectionTitle data-id="element-20">
              Si cuando leíste <span className={gold} data-id="element-21">"Kamasutra"</span>{' '}
              pensaste únicamente en posiciones…
            </SectionTitle>
            <Lead data-id="element-22">No eres la única persona.</Lead>
            <Secondary data-id="element-23">
              Durante años nos hicieron creer que el Kamasutra era simplemente
              un catálogo de técnicas sexuales.
            </Secondary>
            <Secondary data-id="element-24">
              Pero esa es solo una pequeña parte de su historia.
            </Secondary>
            <Lead data-id="element-25">
              El verdadero Kamasutra nació como una filosofía para comprender el{' '}
              <span className={magenta} data-id="element-26">deseo</span>, fortalecer la{' '}
              <span className={magenta} data-id="element-27">conexión</span> y enseñar cómo dos
              personas podían seguir conquistándose con el paso del tiempo.
            </Lead>
            <Lead data-id="element-28">Y precisamente de eso trata esta experiencia.</Lead>
          </Section>

          <GoldDivider className="my-16" data-id="element-29" />

          {/* SECCIÓN 2 */}
          <Section className="space-y-5" data-id="element-30">
            <SectionTitle data-id="element-31">
              Esta no es una clase para hacer más posiciones.
            </SectionTitle>
            <Secondary data-id="element-32">
              Es una clase para entender por qué algunas parejas dejan de
              desearse…
            </Secondary>
            <Lead data-id="element-33">
              mientras otras siguen sintiendo{' '}
              <span className={magenta} data-id="element-34">mariposas</span> incluso después de
              muchos años.
            </Lead>
            <Secondary data-id="element-35">
              Porque la diferencia rara vez está en el amor.
            </Secondary>
            <Lead data-id="element-36">
              La diferencia está en cómo construyen su{' '}
              <span className={gold} data-id="element-37">intimidad</span>.
            </Lead>
          </Section>

          <GoldDivider className="my-16" data-id="element-38" />

          {/* SECCIÓN 3 */}
          <Section className="space-y-6" data-id="element-39">
            <SectionTitle data-id="element-40">
              Lo que <span className={gold} data-id="element-41">descubrirás</span> durante esta
              experiencia
            </SectionTitle>
            <Secondary data-id="element-42">Más que aprender posiciones…</Secondary>
            <Lead data-id="element-43">
              aprenderás a comprender el{' '}
              <span className={magenta} data-id="element-44">comportamiento del deseo</span>.
            </Lead>
            <BulletList marker="✔" items={['Cómo funciona realmente la atracción.', 'Por qué la rutina afecta tanto la pasión.', 'Qué papel juega el cerebro en la intimidad.', 'Cómo conocer el cuerpo cambia por completo la experiencia.', 'Qué posiciones favorecen la cercanía, la comodidad o la intensidad y cuándo utilizarlas.', 'Cómo transformar la intimidad en una herramienta para fortalecer la relación.']} data-id="element-45" />
            {/* CTA #1 */}
            <div className="pt-6" data-id="element-46">
              <CtaButton data-id="element-47" />
            </div>
          </Section>

          <GoldDivider className="my-16" data-id="element-48" />

          {/* SECCIÓN 4 */}
          <Section className="space-y-5" data-id="element-49">
            <div className="relative" data-id="element-50">
              {/* Diffuse glow behind the portrait */}
              <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-[110%] w-[110%] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-40 blur-3xl" style={{
              background: 'radial-gradient(closest-side, rgba(201,162,75,0.3), transparent)'
            }} data-id="element-51" />
              <img src={BEATRIZ_IMAGE} alt="Msc. Beatriz Espina, sexóloga y especialista en conducta" className="relative mx-auto w-full max-w-[420px] rounded-2xl object-cover shadow-2xl ring-1 ring-[#C9A24B]/25" style={{
              boxShadow: '0 30px 80px -30px rgba(0,0,0,0.9)'
            }} data-id="element-52" />
            </div>
            <SectionTitle data-id="element-53">
              ¿Por qué la <span className={magenta} data-id="element-54">DOC</span> decidió enseñar
              Kamasutra?
            </SectionTitle>
            <Secondary data-id="element-55">
              Porque durante años ha acompañado a cientos de personas que
              llegaban convencidas de que el problema era la falta de deseo.
            </Secondary>
            <Secondary data-id="element-56">
              Y descubrió algo que cambió por completo su manera de enseñar.
            </Secondary>
            <Lead data-id="element-57">La mayoría no necesitaba aprender más sobre sexo.</Lead>
            <Lead data-id="element-58">
              Necesitaba aprender a{' '}
              <span className={magenta} data-id="element-59">volver a conectar</span>.
            </Lead>
            <Secondary data-id="element-60">
              Por eso esta clase une ciencia, comportamiento humano, anatomía y
              Kamasutra en una experiencia profundamente educativa, práctica y
              respetuosa.
            </Secondary>
          </Section>

          <GoldDivider className="my-16" data-id="element-61" />

          {/* SECCIÓN 5 */}
          <Section className="space-y-5" data-id="element-62">
            <SectionTitle data-id="element-63">
              Lo que hace <span className={gold} data-id="element-64">diferente</span> esta
              masterclass
            </SectionTitle>
            <Secondary data-id="element-65">No aprenderás posiciones aisladas.</Secondary>
            <Lead data-id="element-66">
              Cada posición tiene un <span className={magenta} data-id="element-67">propósito</span>.
            </Lead>
            <Secondary data-id="element-68">
              Algunas ayudan a fortalecer la conexión emocional.
            </Secondary>
            <Secondary data-id="element-69">Otras facilitan la comunicación.</Secondary>
            <Secondary data-id="element-70">Otras favorecen el contacto visual.</Secondary>
            <Secondary data-id="element-71">
              Algunas permiten descubrir nuevas sensaciones según las
              características físicas de cada pareja.
            </Secondary>
            <Lead data-id="element-72">
              Y todas están explicadas desde la experiencia clínica y
              profesional de la{' '}
              <span className={gold} data-id="element-73">Msc. Beatriz Espina</span>.
            </Lead>
          </Section>

          <GoldDivider className="my-16" data-id="element-74" />

          {/* SECCIÓN 6 */}
          <Section className="space-y-6" data-id="element-75">
            <SectionTitle data-id="element-76">
              Mucho más que una <span className={gold} data-id="element-77">grabación</span>
            </SectionTitle>
            <Lead data-id="element-78">Al acceder hoy recibirás:</Lead>
            <BulletList marker="✨" items={['La masterclass completa.', 'Explicaciones anatómicas sencillas y prácticas.', 'El mapa de las zonas de mayor sensibilidad.', 'Posiciones explicadas paso a paso.', 'Recomendaciones para adaptarlas según cada pareja.', 'Respuestas a preguntas reales de los asistentes.', 'Una nueva forma de entender la intimidad.']} data-id="element-79" />
            {/* CTA #2 */}
            <div className="pt-6" data-id="element-80">
              <CtaButton data-id="element-81" />
            </div>
          </Section>

          <GoldDivider className="my-16" data-id="element-82" />

          {/* SECCIÓN 7 */}
          <Section className="space-y-6" data-id="element-83">
            <SectionTitle data-id="element-84">
              Esta experiencia es <span className={magenta} data-id="element-85">para ti</span> si...
            </SectionTitle>
            <BulletList marker="✔" items={['Quieres salir de la rutina sin caer en lo superficial.', 'Buscas fortalecer tu relación desde el conocimiento.', 'Te interesa comprender el deseo más allá de los mitos.', 'Deseas sorprender a tu pareja desde la conexión y no solo desde la técnica.', 'Crees que una gran relación también se construye aprendiendo.']} data-id="element-86" />
          </Section>

          <GoldDivider className="my-20" data-id="element-87" />

          {/* CIERRE */}
          <Section className="space-y-5 text-center" data-id="element-88">
            <div className="relative" data-id="element-89">
              <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-56 w-[130%] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-50 blur-3xl" style={{
              background: 'radial-gradient(closest-side, rgba(196,30,90,0.28), rgba(201,162,75,0.18), transparent)'
            }} data-id="element-90" />
              <p className="font-serif-editorial relative text-[26px] leading-[1.35] text-[#F5EDE4] sm:text-[32px]" data-id="element-91">
                El verdadero Kamasutra nunca enseñó solamente cómo unir dos
                cuerpos.
              </p>
            </div>
            <Lead className="!text-[#E7C9B8]" data-id="element-92">
              Enseñó cómo mantener viva la curiosidad.
            </Lead>
            <Lead className="!text-[#E7C9B8]" data-id="element-93">La admiración.</Lead>
            <Lead className="!text-[#E7C9B8]" data-id="element-94">La complicidad.</Lead>
            <Lead data-id="element-95">
              Y el deseo de <span className={magenta} data-id="element-96">seguir eligiéndose</span>.
            </Lead>
            <Secondary data-id="element-97">
              Hoy tienes la oportunidad de descubrir esa filosofía desde una
              mirada profesional, cercana y profundamente humana.
            </Secondary>
            <Lead data-id="element-98">
              Bienvenido(a) a una experiencia que puede cambiar la manera en que
              entiendes la <span className={gold} data-id="element-99">intimidad</span>.
            </Lead>

            {/* CTA #3 — large final */}
            <div className="pt-8" data-id="element-100">
              <CtaButton size="large" data-id="element-101" />
            </div>

            {/* Emotional closing quote under the final button */}
            <p className="mx-auto max-w-[560px] pt-6 text-[16px] italic leading-[1.7] text-[#E7C9B8] sm:text-[18px]" data-id="element-102">
              "No es una clase para aprender posiciones. Es una masterclass para
              aprender a mantener viva la conexión, el deseo y la complicidad en
              una relación."
            </p>
          </Section>
        </main>
      </div>

      {/* MOBILE STICKY CTA */}
      <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[#C9A24B]/25 bg-[#1A1014]/95 px-4 py-3 backdrop-blur-md lg:hidden" data-id="element-103">
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex w-full items-center justify-center rounded-full px-6 py-3.5 text-base font-semibold uppercase tracking-wide text-[#1A1014] transition-transform duration-300 ease-out active:scale-[0.98]" style={{
        backgroundImage: 'linear-gradient(135deg, #E8C877 0%, #C9A24B 45%, #A87F2E 100%)',
        boxShadow: '0 8px 30px -6px rgba(201, 162, 75, 0.55)'
      }} data-id="element-104">
          QUIERO ACCEDER AHORA
        </a>
      </div>
    </div>;
}